import useUrlNavigation from "hooks/useUrlNavigation";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import { Fragment } from "react";
import { Link, NavLink } from "react-router-dom";
import Maybe from "./Maybe";

const TabSettings = (props) => {
    const {urlQueryParams} = useUrlQueryParams();
    const {urlQuery} = useUrlNavigation();
    
    
    const qname = urlQueryParams[props.options[0]?.queryName];
    

    const isActive = (option) => {
        if (qname === null || qname === undefined){
            if (option.queryValueDefault === true){
                return "active";
            }
        }
        else if (qname === option.queryValue){
            return "active";
        }
        return "";
    }


    return ( 
        <div className="-mt-4 overflow-auto relative top-px">
            
            <div className="flex">
                {props.options?.map((option, index) =>
                    (option &&
                        <Fragment key={index}>
                            <Maybe condition={option.type === "query"}>
                                <Link to={urlQuery(option.queryName + "=" + option.queryValue)} className={"tab flex-shrink-0 " + (isActive(option))}>
                                    {option.title}
                                </Link>
                            </Maybe>

                            <Maybe condition={option.type === "link"}>
                                <Maybe condition={option.removeAutoActive !== true}>
                                    <NavLink to={option.url || ""} className="tab flex-shrink-0">
                                        {option.title}
                                    </NavLink>
                                </Maybe>
                                <Maybe condition={option.removeAutoActive === true}>
                                    <Link to={option.url || ""} className="tab flex-shrink-0">
                                        {option.title}
                                    </Link>
                                </Maybe>
                            </Maybe>

                            <Maybe condition={option.type === "div"}>
                                <div onClick={option.onclick || null} className={"tab flex-shrink-0 cursor-pointer " + (option.isActive === true ? "active" : "")}>
                                    {option.title}
                                </div>
                            </Maybe>
                        </Fragment>
                    )
                )}
            </div>

        </div>
    )
}

export default TabSettings;